// src/modules/Files/utils/upload-file.ts
var uploadFile = (file, onProgress, opts) => {
	if (!file) {
		console.error("uploadFile(file) no file provided");
		alert("File system error, please select the file(s) again.");
		throw new Error("uploadFile(file) File system error, no file");
	}
	if (!file.uploadUrl || !file.uploadMethod) throw new Error("uploadFile(file) file must have \"uploadUrl\" and \"uploadMethod\"");
	let abortPromise = () => {
		throw new Error("uploadFile()#abortPromise never set by XHR");
	};
	const uploadPromise = new Promise(function(resolve, reject) {
		const xhr = new XMLHttpRequest();
		xhr.addEventListener("error", (event) => {
			console.log("Upload file error", event);
		});
		xhr.onreadystatechange = () => {
			if (xhr.readyState === 4) {
				if (xhr.status === 200) resolve(xhr);
				else reject(xhr);
			}
		};
		let timeoutId;
		let previousUploadProgressUpdate = 0;
		xhr.upload.onprogress = (e) => {
			if (timeoutId) clearTimeout(timeoutId);
			timeoutId = setTimeout(() => {
				abortPromise();
			}, opts?.timeout || 1e4);
			if (onProgress && e.lengthComputable) {
				const percentComplete = +(e.loaded / file.size * 100).toFixed(0);
				if (percentComplete >= previousUploadProgressUpdate + 5 || percentComplete === 100) {
					previousUploadProgressUpdate = percentComplete;
					onProgress(percentComplete);
				}
			}
		};
		xhr.open(file.uploadMethod, file.uploadUrl);
		xhr.send(file.file);
		abortPromise = () => {
			xhr.abort();
		};
	});
	return {
		abortPromise,
		uploadPromise
	};
};
export { uploadFile };

//# sourceMappingURL=upload-file.js.map